import React, { useContext, useEffect, useState } from 'react';
import { useMutation } from 'graphql-hooks';
import { NavLink } from 'react-router-dom';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Breadcrumb,
  Typography
} from 'antd';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Context as AuthContext } from '../context/AuthContext';
import { MailOutlined, LockOutlined } from '@ant-design/icons';

import { Redirect } from "react-router";
import { SET_RESET_PASSWORD } from '../mutations';

const INITIAL_VALUES = {
  password: '',
  passwordConfirmation: ''
}

const PasswordReset = (props) => {
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const [setPassword, { data, error, loading }] = useMutation(SET_RESET_PASSWORD);
  const { Title, Text } = Typography;
  const { setNavigation, signout } = useContext(AuthContext);

  useEffect(() => {
    signout();
    setNavigation(3);
    forceUpdate({});
  }, [])

  if (props.location.search === "") {
    return (
      <Redirect to="/" />
    )
  }

  const setNewPassword = async (values) => {
    console.log(values);
    const { password, passwordConfirmation } = values;
    if (password, passwordConfirmation) {
      if (password === passwordConfirmation) {
        const params = new URLSearchParams(props.location.search)
        setPassword({
          variables: {
            password: password,
            hash: params.get('token')
          }
        })
          .then(({ data, error }) => {
            if (error) {
              toast.error(error, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
            if (data.forgotPassword) {
              form.resetFields();
              toast.success(data.forgotPassword, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          })
      }


    }
  }

  return (
    <div>
      <Row type="flex" style={{ backgroundColor: 'white', padding: 10 }} >
        <Col span={24}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <NavLink to="/">Inicio</NavLink>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              Olvido su contraseña
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col xs={{ span: 0 }} sm={{ span: 0 }} md={{ span: 8, offset: 4 }} lg={{ span: 8, offset: 4 }} >
          <img src={require('../assets/imagen.jpg')} style={{ width: '100%' }} alt="Logo Laboratorio origen" />
        </Col>
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} style={{ paddingLeft: '10px', paddingRight: '10px', alignSelf: 'center' }}>
          <Title level={3} style={{ marginTop: '30px', marginBottom: '20px', textAlign: 'center' }}>Por favor ingresa la nueva contraseña para tu cuenta</Title>
          <Form
            form={form}
            labelCol={{ span: 12 }}
            wrapperCol={{ span: 23 }}
            layout="vertical"
            initialValues={INITIAL_VALUES}
            size='large'
          >
            <Row type="flex" style={{ backgroundColor: 'white', padding: 10 }} >
              <Col span={24}>
                <Form.Item
                  label="Contraseña"
                  name="password"
                  rules={[{ required: true, message: 'Ingresa una contraseña.' }]}
                >
                  <Input
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    type="password"
                    style={{ borderRadius: '8px' }}
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Confirma tu Contraseña"
                  name="passwordConfirmation"
                  rules={[{ required: true, message: 'Confirma tu contraseña.' }]}
                >
                  <Input
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    type="password"
                    style={{ borderRadius: '8px' }}
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col span={12} offset={6}>
                <Form.Item shouldUpdate={true}>
                  {() => (
                    <Button
                      style={{ width: '100%' }}
                      type="primary"
                      htmlType="submit"
                      onClick={() => setNewPassword(form.getFieldsValue())}
                      loading={loading}
                    >
                      Cambiar contraseña
                    </Button>
                  )}
                </Form.Item>
                {error ?
                  error.graphQLErrors.map((item, i) =>
                    <Form.Item key={i}>
                      <Typography level={4} style={{ textAlign: 'center', color: 'red' }}>{item.message}</Typography>
                    </Form.Item>
                  ) : null
                }
                {
                  data && data.setPassword ?
                    <Form.Item>
                      <Typography level={2} style={{ textAlign: 'center', color: 'green' }}>{data.setPassword}</Typography>
                    </Form.Item>
                    : null
                }
                <Form.Item>
                  <NavLink to="/login">
                    <Typography level={4} style={{ textAlign: 'center', color: 'blue' }}>Inicia sesion</Typography>
                  </NavLink>
                </Form.Item>
              </Col>
            </Row>
            <ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </Form>
        </Col>
        <Col xs={{ span: 0 }} sm={{ span: 0 }} md={{ span: 4 }} lg={{ span: 4 }} ></Col>
      </Row>
    </div>
  )
}

export default PasswordReset;